import React from "react";
import { useParams } from "react-router";
import { Navigate } from "react-router-dom";

import Page from "../../elements/Page/Page";
import CampaignAdsBox from "./CampaignAdsBox";
import CampaignLinkBox from "./CampaignLinkBox";
import CampaignDetailsBox from "./CampaignDetailsBox";

import {isLoggedIn} from "../../utils/utils";

const CampaignDetailsPage = () => {
  const { hash } = useParams();

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace={true} />
  }

  return (
    <Page>
      <CampaignDetailsBox hash={hash} />
      <CampaignLinkBox hash={hash} />
      <CampaignAdsBox hash={hash} category={'text'}/>
      <CampaignAdsBox hash={hash} category={'square'}/>
      <CampaignAdsBox hash={hash} category={'landscape'}/>
      <CampaignAdsBox hash={hash} category={'portrait'}/>
    </Page>
  );
}

export default CampaignDetailsPage;